let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3ZAtx")).then(() => parcelRequire('1f7Pm'));